export default __webpack_public_path__ + "static/media/photo-owner-1.e6261776.png";